import React, { useState } from 'react';
import { FaTrashAlt } from 'react-icons/fa';

type TextAlign = 'left' | 'right' | 'center' | 'justify';

const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f9f9f9',
      padding: '20px',
    },
    icon: {
      color: '#ff4d4f',
      marginBottom: '20px',
    },
    title: {
      fontSize: '2rem',
      marginBottom: '10px',
    },
    disclaimer: {
      color: '#888',
      marginBottom: '20px',
      textAlign: 'center' as TextAlign,
      maxWidth: '400px',
    },
    input: {
      padding: '10px',
      fontSize: '1rem',
      width: '300px',
      borderRadius: '5px',
      border: '1px solid #ccc',
      marginBottom: '20px',
    },
    button: {
      padding: '10px 20px',
      fontSize: '1rem',
      backgroundColor: '#ff4d4f',
      color: '#fff',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    },
  };
  
const DeleteDataScreen = () => {
  const [email, setEmail] = useState('');

  const handleDeleteRequest = () => {
    // You can implement your logic for handling the delete request here
    alert(`A deletion request has been sent for ${email}`);
  };

  return (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f9f9f9',
        padding: '20px',
      }}>
      <FaTrashAlt size={50} style={styles.icon} />
      <h1 style={styles.title}>Delete your data</h1>
      <p style={styles.disclaimer}>
        You will be sent an email to confirm the deletion of your data.
      </p>
      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={styles.input}
      />
      <button onClick={handleDeleteRequest} style={styles.button}>
        Confirm Deletion
      </button>
    </div>
  );
};


export default DeleteDataScreen;
